module.exports = __webpack_public_path__ + "static/media/documentsImage.310067d4.png";